import { lazy } from 'react';

export const LazyFontCardPage = lazy(() => import('./FontCardPage'));
export const LazyFontPage = lazy(() => import('./FontPage'));
